import { db } from "../../../../mp-database"
import parseSnapshot from "../../parseSnapshot"
import { values } from "mout/object"

/**
 * Fetches answers by item matching userAssessmentId from db
 * @param {string} userAssessmentId the id of the userAssessment
 * @returns {object} answersByItem
 */
export default function getAnswersByItem(userAssessmentId) {
  return db
    .collection("answersByItem")
    .where("userAssessmentId", "==", userAssessmentId)
    .get()
    .then(querySnapshot => {
      const records = values(parseSnapshot(querySnapshot))
      let answersByItem = {}
      records.forEach(record => {
        answersByItem[record.subtestId] = record.answers || {}

        if (record.gridInputs) {
          answersByItem[record.subtestId] = {
            ...answersByItem[record.subtestId],
            gridInputs: record.gridInputs
          }
        }
      })
      return answersByItem || {}
    })
}
